const initialValues = {
  board_id: '',
  level: '',
  status: '1',
  name: '',
  description: '',
};

export default initialValues;
